import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Heading,
  Text,
  Input,
  Button,
  Badge,
  VStack,
  FormControl,
  FormLabel,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from '@chakra-ui/react';

const Register = () => {
  const { register, error } = useAuth();
  const [form, setForm] = useState({ username: '', password: '', name: '' });
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (register(form)) {
      setSuccess(true);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bgGradient="linear(to-br, blue.50, purple.100)">
      <Card maxW="md" w="full" boxShadow="2xl" borderRadius="2xl" p={6}>
        <CardHeader textAlign="center">
          <VStack spacing={2}>
            <img src="https://cdn-icons-png.flaticon.com/512/5968/5968705.png" alt="SaaS Logo" width={64} height={64} />
            <Heading size="lg">SaaS Admin Portal</Heading>
            <Badge colorScheme="green" fontSize="0.9em">Create Account</Badge>
            <Text color="gray.500" fontSize="sm">Create your account to manage your SaaS business and users.</Text>
          </VStack>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardBody as={VStack} spacing={4}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input name="name" value={form.name} onChange={handleChange} placeholder="Name" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Username</FormLabel>
              <Input name="username" value={form.username} onChange={handleChange} placeholder="Username" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Password</FormLabel>
              <Input name="password" value={form.password} onChange={handleChange} placeholder="Password" type="password" />
            </FormControl>
            {error && <Badge colorScheme="red" fontSize="0.9em">{error}</Badge>}
            {success && <Badge colorScheme="green" fontSize="0.9em">Registration successful! (Dummy, no real registration)</Badge>}
          </CardBody>
          <CardFooter flexDirection="column" alignItems="center" gap={2}>
            <Button type="submit" colorScheme="green" w="full" size="lg">Register</Button>
            <Text fontSize="xs" color="gray.400" textAlign="center" mt={2}>
              Already have an account? Login with a demo user: <br/> superadmin/superadmin123, admin/admin123, user/user123
            </Text>
          </CardFooter>
        </form>
      </Card>
    </Box>
  );
};

export default Register; 